var cityDataInfo = []
export default cityDataInfo;


// WEBPACK FOOTER //
// ./src/utils/CityData.js